import {Component, forwardRef, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import moment from 'moment/moment';

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DatepickerComponent)}
  ],
})
export class DatepickerComponent implements ControlValueAccessor, OnInit, OnDestroy, OnChanges {
  @Input() control?: FormControl;
  @Input() required: boolean;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() minDate: string | moment.Moment | null = null;
  @Input() maxDate: string | moment.Moment | null = null;
  @Input() dateFilter;

  value?: any = null;
  disabled = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
  ) {
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {
    if (!this.control) {
      this.control = new FormControl('');
    }

    this.control.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.value = data;
          this.onChange(data);
        } else {
          this.value = null;
          this.onChange(null);
        }
      });
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value): void {
    this.control.setValue(value);
    this.value = value;
  }
  clearValue(): void {
    this.control.setValue(null);
    this.writeValue(null);
    this.onChange(null);
  }
}
